<template>
  <div>
    <h3 class="text-bold">Update Delivery</h3>
    <!-- Order Header -->
    <div
      class="row"
      style="background: #fff; margin: 0px; padding: 5px; margin-bottom: 20px"
    >
      <div class="col-md-2">
        <div class="form-group">
          <h5 class="text-bold" style="padding-top: 7px">
            Choose Delivery Date
          </h5>
          <datepicker
            v-model="delivery.delivery_date_picked"
            @input="selectDeliveryDate()"
            placeholder="Select Date"
            :input-class="{
              'has-error': errors.delivery_date,
              'date-input': true,
            }"
            wrapper-class="date-input-wrapper"
            bootstrap-styling
          ></datepicker>
          <small v-if="errors.delivery_date" class="form-text text-danger">{{
            errors.delivery_date.join(" ")
          }}</small>
        </div>
      </div>
      <div class="reference-container col-md-6 text-right">
        <h5 class="text-bold">Order Reference #</h5>
        <h1 class="text-bold">
          {{ delivery.order_reference }}
        </h1>
      </div>
      <div class="reference-container col-md-4 text-right">
        <h5 class="text-bold">Delivery Reference #</h5>
        <h1 class="text-bold">
          {{ formatPotentialDeliveryReference() }}
        </h1>
        <small v-if="errors.delivery_reference" class="form-text text-danger">{{
          errors.delivery_reference.join(" ")
        }}</small>
      </div>
    </div>
    <!-- Order Header -->

    <!-- Order Details -->
    <div id="order-table" class="grid shadow bg-white mt-10">
      <div class="grid-body">
        <table class="table table-condensed p-0">
          <thead>
            <tr>
              <th></th>
              <th>Fabric ID</th>
              <th>Fabric Name</th>
              <th>Order Amount</th>
              <th>Delivery Amount</th>
              <th>Unit</th>
              <th>Length Unit</th>
              <th>Calculated Roll Length</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(fabric, fabricIndex) in delivery.fabrics">
              <tr>
                <td class="bg-info col-sm-1">
                  <a
                    class="fabric-toggle"
                    v-if="fabric.expanded"
                    @click="toggleFabricRows(fabric)"
                  >
                    <span class="fa fa-caret-down fa-2x"></span>
                  </a>
                  <a
                    class="fabric-toggle"
                    v-if="!fabric.expanded"
                    @click="toggleFabricRows(fabric)"
                  >
                    <span class="fa fa-caret-right fa-2x"></span>
                  </a>
                </td>
                <td class="bg-info">{{ fabric.id }}</td>
                <td class="bg-info">{{ fabric.name }}</td>
                <td class="bg-info col-sm-2">{{ ezy.comma(fabric.amount_ordered) }}</td>
                <td
                  class="bg-info col-sm-2"
                  :class="{
                    'alert-over-amount-ordered':
                      fabric.amount_delivered > fabric.amount_ordered,
                  }"
                >
                  {{ ezy.comma(fabric.amountDeliveredForCurrentFabric || fabric.amount_delivered) }}
                </td>
                <td class="bg-info">{{ fabric.unit }}</td>
                <td class="bg-info">
                  <select style="width: 100px;" :value="fabric.selectedUnit" v-model="fabric.selectedUnit">
                    <option value="m">Meters</option>
                    <option value="y">Yards</option>
                    <option value="kg">Kilogram</option>
                  </select>
                </td>
                <td class="bg-info">
                    {{ ezy.comma(fabric.is_jersey_fabric ? convertJerseyFabricRollLengthToMeterOrYard(fabric, fabric.selectedUnit) : convertFabricRollLengthToMeterOrYard(fabric, fabric.selectedUnit)) }} {{ fabric.selectedUnit }}
                </td>
                <td class="bg-info text-right">
                  <button @click="addRoll(fabric)" class="btn btn-info">
                    Add Roll
                  </button>
                </td>
              </tr>
              <tr
                v-for="(roll, rollIndex) in fabric.rolls"
                v-if="fabric.expanded"
              >
                <td></td>
                <td class="">#{{ roll.rollIndex }}</td>
                <td class="">
                  {{ getRollCode(fabric, roll, fabricIndex, rollIndex) }}
                  <small
                    v-if="
                      errors[
                        'fabrics.' +
                          fabricIndex +
                          '.rolls.' +
                          rollIndex +
                          '.code'
                      ]
                    "
                    class="form-text text-danger"
                    >Code is required</small
                  >
                </td>
                <td class="col-sm-2">-</td>
                <td class="col-sm-2">
                  <money
                    class="form-control"
                    :disabled="roll.status !== 'warehouse'"
                    v-model="roll.amount_delivered"
                    @input="calculateFabricAmountDelivered(fabric)"
                    v-bind="money"
                  />
                  <small
                    v-if="
                      errors[
                        'fabrics.' +
                          fabricIndex +
                          '.rolls.' +
                          rollIndex +
                          '.amount_delivered'
                      ]
                    "
                    class="form-text text-danger"
                    >Amount is required</small
                  >
                </td>
                <td class="">{{ fabric.unit }}</td>
                <td colspan="3" class="text-right" style="width: 300px">
                  <button
                    class="btn btn-danger"
                    :disabled="roll.status !== 'warehouse'"
                    @click="deleteRoll(fabric, rollIndex)"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Order Details -->
    <button class="btn-primary btn-large btn btn-block" @click="saveData()">
      Update Delivery
    </button>
  </div>
</template>
<script>
import { Money } from "v-money";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker,
    Money
  },
  data() {
    return {
      errors: [],
      deliveryRef: {
        nextDeliveryId: "",
        date: moment(new Date()).format("YYYY/MM/DD"),
        supplierCode: "{code}",
        postfix: "",
      },
      delivery: {
        order_reference: "",
        fabrics: [],
      },
      loading: false,
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
    };
  },
  async mounted() {
    await this.getPageData();
  },
  methods: {
    getRollCode(fabric, roll, fabricIndex, rollIndex) {
      let date = moment(this.delivery.delivery_date_picked).format(
        "YYYY-MM-DD"
      );
      let supplier = this.delivery.supplier_code;
      let fabricId = fabric.id;
      let amount = roll.amount_delivered;
      let unqueId = `${this.pad(rollIndex + 1)}`;
      let code = `${date}-${supplier}-${this.deliveryRef.nextDeliveryId}-${fabricId}-${amount}-${unqueId}`;
      this.delivery.fabrics[fabricIndex].rolls[rollIndex].code = code;
      return code;
    },

    pad(number, width = 3, padWith = "0") {
      number = number + "";
      return number.length >= width
        ? number
        : new Array(width - number.length + 1).join(padWith) + number;
    },

    async getPageData() {
      let orderId = this.$route.params.order_id;
      let deliveryId = this.$route.params.delivery_id;

      try {
        let results = await axios({
          method: "get",
          url:
            "/v2/fabrics/order/" +
            orderId +
            "/delivery/" +
            deliveryId +
            "/edit",
        });
        let data = results.data.data;
        this.delivery = data;
        this.delivery.delivery_date_picked = moment(new Date()).format(
          "YYYY/MM/DD"
        );
        this.deliveryRef.supplierCode = data.supplier_code;
        this.deliveryRef.nextDeliveryId = data.next_delivery_id;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    async saveData() {
      this.errors = [];
      this.loading = true;
      try {
        let orderId = this.$route.params.order_id;
        let deliveryId = this.$route.params.delivery_id;
        this.delivery.delivery_date = moment(
          this.delivery.delivery_date_picked
        ).format("YYYY-MM-DD");
        this.delivery.delivery_reference = this.formatPotentialDeliveryReference();
        this.delivery.delivery_id = deliveryId;

        let results = await axios({
          method: "put",
          url: "/v2/fabrics/order/" + orderId + "/delivery/" + deliveryId,
          data: this.delivery,
        });
        this.loading = false;
        this.$router.back();
      } catch (error) {
        this.loading = false;
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
        }
      }
    },

    getTotalRows() {
      let rollCount = 0;
      this.delivery.fabrics.map((fabric) => {
        fabric.rolls.map((roll) => {
          rollCount++;
        });
      });
      return rollCount;
    },

    selectDeliveryDate() {
      this.deliveryRef.date = moment(this.delivery.delivery_date_picked).format(
        "YYYY-MM-DD"
      );
      this.regenerateRollCodes();
    },

    calculateFabricAmountDelivered(fabric) {
      let sum = 0;
      fabric.rolls.forEach((roll) => {
        sum += parseFloat(roll.amount_delivered) || 0
      })
      fabric.amountDeliveredForCurrentFabric = sum
    },

    toggleFabricRows(fabric) {
      let currentStatus = fabric.expanded;
      fabric.expanded = !currentStatus;
    },

    addRoll(fabric) {
      let nextIndex = fabric.rolls.length + 1;
      fabric.rolls.push({
        index: nextIndex,
        code: null,
        amount_delivered: 0,
        status: "warehouse",
      });
      fabric.expanded = true;
    },

    deleteRoll(fabric, rollIndex) {
      let deletedRoll = fabric.rolls.splice(rollIndex, 1)[0];
      fabric.deletedRolls.push(deletedRoll);
      this.reindexRolls(fabric);
    },

    reindexRolls(fabric) {
      let i = 1;
      fabric.rolls.map((roll) => {
        roll.index = i;
        i++;
      });
      this.calculateFabricAmountDelivered(fabric);
    },

    async editOrderReference() {
      var self = this;
      await Swal.fire({
        title: "Add a postfix to the Order Reference",
        input: "text",
        inputValue: this.newOrderId.postfix,
        showCancelButton: true,
        inputValidator: (value) => {
          this.newOrderId.postfix = value;
        },
      });
    },

    formatPotentialDeliveryReference() {
      let deliveryId =
        this.deliveryRef.nextDeliveryId +
        "-" +
        this.deliveryRef.date +
        "-" +
        this.deliveryRef.supplierCode;
      deliveryId +=
        this.deliveryRef.postfix !== "" ? "-" + this.deliveryRef.postfix : "";
      return deliveryId;
    },

    convertJerseyFabricRollLengthToMeterOrYard(fabric, unit = 'm') {
      let defaultWeight = parseFloat(fabric.default_weight);
      let meterPerKg = 0;

      if(fabric.knit_type === 'open') {
        meterPerKg = 1000 / ((parseFloat(fabric.default_width) + 2) * defaultWeight * 0.0232);
      } else {
        meterPerKg = 1000 / (parseFloat(fabric.default_width) * 2 * defaultWeight * 0.0232);
      }

      let lengthInMeters = fabric.amount_ordered * meterPerKg;

      if (unit == 'y') {
        return lengthInMeters * 1.094;
      }

      return lengthInMeters;
    },

    convertFabricRollLengthToMeterOrYard(fabric, unit = 'm') {
      const conversionRates = {
          'm_to_y': 1.094,
          'y_to_m': 0.9144
      };

      if (fabric.unit === unit) {
          return fabric.amount_ordered;
      }

      if (fabric.unit === 'm' && unit === 'y') {
          // Convert meters to yards
          return fabric.amount_ordered * conversionRates.m_to_y;
      }

      if (fabric.unit === 'y' && unit === 'm') {
          // Convert yards to meters
          return fabric.amount_ordered * conversionRates.y_to_m;
      }

      return fabric.amount_ordered;
  }

  },
};
</script>
<style scoped>
@import "~sweetalert2/dist/sweetalert2.min.css";
@import "~vue-select/dist/vue-select.css";

.grid-body {
  padding-bottom: 0px !important;
}

/** Order Reference */
div.reference-container h5 {
  margin-bottom: 0px;
  padding-top: 8px;
}

div.reference-container h1 {
  margin: 0px;
}

input.date-input {
  width: 100% !important;
}

div.input-group {
  width: 100% !important;
  background: #ff0;
}

.vdp-datepicker .input-group {
  width: 100% !important;
}

a.fabric-toggle {
  cursor: pointer;
}

/** Order Table */
div#order-table table th {
  border: 0px !important;
}

div#order-table table tr td {
  vertical-align: top;
}

div#order-table table thead th {
  vertical-align: middle;
}

div#order-table table tfoot tr td {
  border-top: 2px solid #e5e5e5;
  font-weight: bold;
}

.alert-over-amount-ordered {
  color: red !important;
  text-decoration: underline;
}

/** Form Error States */

div#order-table input.has-error,
div#order-table select.has-error,
div#order-table .v-select.has-error {
  border: 1px solid #a94442 !important;
}

.disabled {
  background: #ececec;
  cursor: not-allowed;
}

.unit {
  width: 150px !important;
}

.select-fabric {
  width: 250px;
}

small.form-text {
  display: block;
}
</style>
